export const MIME_TYPES = {
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PPT: 'application/vnd.ms-powerpoint',
  PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  TXT: 'text/plain',
  CSV: 'text/csv',
  JPG: 'image/jpeg',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  GIF: 'image/gif',
  SVG: 'image/svg+xml',
  MP3: 'audio/mpeg',
  WAV: 'audio/wav',
  MP4: 'video/mp4',
  MOV: 'video/quicktime',
  ZIP: 'application/zip',
  RAR: 'application/vnd.rar',
  JSON: 'application/json'
};

export const SCORING_MODELS = {
  WEIGHTED: 'weighted',
  NON_WEIGHTED: 'non-weighted'
};

export const SECTION_TYPES = {
  SCORE: 'score',
  AUDIT: 'audit'
};

export const RECORDING_STATE = {
  INIT: 'comfort-zone',
  RECORDING: 'recording',
  STOPPED: 'stopped',
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  UPLOAD_FAILED: 'upload_failed',
  ERROR: 'error',
  PROMPT: 'prompt',
  GRANTED: 'granted',
  DENIED: 'denied',
  VALIDATING: 'validating',
  CORRUPTION_DETECTED: 'corruption_detected',
  RETRYING: 'retrying',
  NETWORK_ERROR: 'network_error'
};

export const PUBLIC_RECORDING_STATUS = {
  UNPUBLISHED: 'unpublished',
  PUBLISHED: 'published'
};

export const INTERVIEW_TYPE = {
  VIDEO_QUESTION: 'video-question',
  RESUME_PROFILE: 'resume-profile',
  TYPING_ASSESSMENT: 'typing-assessment'
};

export const EXTERNAL_ASSESSMENT_TYPE = {
  LANGUAGE: 'language',
  WRITING: 'writing'
};

export const INTERVIEW_RESULT_STATUS = {
  NEW: 'new',
  SENT: 'sent',
  SUBMITTED: 'submitted',
  EVALUATED: 'evaluated',
  ABANDONED: 'abandoned'
};

export const APPLICANT_STATUS = {
  incomplete: 'Incomplete',
  declined: 'Declined',
  sent_to_operations: 'Sent to Operations',
  interview_scheduled: 'Interview Scheduled',
  recommended: 'Recommended',
  for_offer: 'For Offer',
  offer_accepted: 'Offer Accepted',
  complete: 'Complete'
};

export const APPLICANT_STATUS_VERBIAGE = {
  recommended: 'This applicant is recommended to the client.',
  declined: 'The applicant does not meet the qualifications and has been declined.',
  interview_scheduled: 'The applicant requires a face-to-face interview and that has been scheduled.',
  sent_to_operations: 'The application has been sent to operations.',
  for_offer: 'The applicant meets all qualifications and has been extended an offer.',
  offer_accepted: 'The applicant has accepted the offer and is scheduled for training.'
};

export const APPLICANT_STATUS_REASON = {
  DEC000: 'Prescreen Resume & Qualifications',
  DEC001: 'Looking for Higher Compensation',
  DEC002: 'Did Not Meet Minimum Resume Requirements',
  DEC003: 'No Call Center Experience',
  DEC004: 'Did Not Meet Minimum Qualifications',
  DEC005: 'Poor Communication Skills',
  DEC006: 'Looking for WFH',
  DEC007: 'Current Employed/No Longer Exploring',
  DEC008: 'Personal Reasons, and Poor Behavior'
};

export const OPERATIONS = {
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  // Custom Operation
  SMALL_TEAMS: 'small_teams'
};

export const MENU_PERMISSIONS = {
  view: 'View',
  edit: 'Edit',
  delete: 'Delete',
  small_teams: 'Small Teams'
};

export const INITIAL_PERMISSIONS = {
  view: false,
  edit: false,
  delete: false
};

export const DEGREES = ['High School Diploma', "Associate's Degree", "Bachelor's Degree", "Master's Degree", 'Doctorate', 'Other'];

export const REQUISITION_STATUS = {
  draft: 'Draft',
  opened: 'Opened',
  // partial: 'Partial',
  moved: 'Moved',
  filled: 'Filled',
  cancelled: 'Cancelled'
};

export const REQUISITION_STATUS_VERBIAGE = {
  partial: 'This is when the requisition was due and was only partially filled.',
  moved: 'This is when either the client submission date or the class start date is moved.',
  filled: 'This is when the class is considered filled.',
  cancelled: 'This is when a requisition is cancelled.'
};

export const LOCATIONS = [
  { value: 'philippines', label: 'Philippines' },
  { value: 'costa-rica', label: 'Costa Rica' },
  { value: 'south-africa', label: 'South Africa' },
  { value: 'india', label: 'India' },
  { value: 'usa', label: 'USA' }
];

export const EMPLOYMENT_TYPES = [
  { value: 'part-time', label: 'Part-time' },
  { value: 'full-time', label: 'Full-time' }
];

export const WORK_ENVIRONMENTS = [
  { value: 'remote', label: 'Remote' },
  { value: 'onsite', label: 'Onsite' }
];

export const REQUISITION_TYPES = [
  {
    label: 'BPO',
    value: 'bpo'
  },
  {
    label: 'Corporate',
    value: 'corporate'
  },
  {
    label: 'Small Teams',
    value: 'small-teams'
  }
];

export const REQUISITION_STAGE = {
  JOB_DESCRIPTION: 'job-description',
  INSTRUCTIONS_REMINDERS: 'instructions-reminders',
  PERSONAL_INFO: 'personal-info',
  RESUME_PROFILE: 'resume-profile',
  QUALIFICATION_QUESTIONS: 'qualification-questions',
  PRE_SCREENING: 'pre-screening',
  VIDEO_QUESTIONS: 'video-questions',
  TYPING_ASSESSMENT: 'typing-assessment',
  SUCCESS: 'success'
};

export const LOB_TYPE = {
  SMALL_TEAMS: 'small-teams',
  BPO: 'bpo'
};

export const LOB_TYPES = [
  {
    label: 'Small Teams',
    value: 'small-teams'
  },
  {
    label: 'BPO',
    value: 'bpo'
  }
];

export const QUESTION_TYPE = {
  TEXT: 'text-entry',
  MCQ: 'multiple-choice'
};
